import { render, staticRenderFns } from "./Pharmacy.vue?vue&type=template&id=d2aa477a&scoped=true"
import script from "./Pharmacy.vue?vue&type=script&lang=js"
export * from "./Pharmacy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2aa477a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/node-apps/im.ingenes.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d2aa477a')) {
      api.createRecord('d2aa477a', component.options)
    } else {
      api.reload('d2aa477a', component.options)
    }
    module.hot.accept("./Pharmacy.vue?vue&type=template&id=d2aa477a&scoped=true", function () {
      api.rerender('d2aa477a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Admin/Pharmacy.vue"
export default component.exports